<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M24 38H7a2 2 0 00-2 2v17a2 2 0 002 2h17a2 2 0 002-2V40a2 2 0 00-2-2zm-1 18H8V41h15zM57.5 41h-24a1.5 1.5 0 000 3h24a1.5 1.5 0 000-3zM57.5 53h-24a1.5 1.5 0 000 3h24a1.5 1.5 0 000-3zM24 5H7a2 2 0 00-2 2v17a2 2 0 002 2h17a2 2 0 002-2V7a2 2 0 00-2-2zm-1 18H8V8h15zM33.5 11h24a1.5 1.5 0 000-3h-24a1.5 1.5 0 000 3zM57.5 20h-24a1.5 1.5 0 000 3h24a1.5 1.5 0 000-3z"/></svg>